import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function stripMarkdown(markdown: string) {
  if (!markdown) return '';
  return markdown
    // Remove headers like # or ## or ###
    .replace(/^#+\s+/gm, '')
    // Remove bold and italic ** or *
    .replace(/\*{1,2}([^\*]+)\*{1,2}/g, '$1')
    // Remove custom buttons like [Botão: Texto]
    .replace(/\[Botão:\s*([^\]]+)\]/gi, '')
    // Replace multiple newlines with a single space
    .replace(/\s+/g, ' ')
    .trim();
}

export function getBlogMeta(post: { copy_hook?: string | null, copy_text?: string | null }) {
  let title = post.copy_hook || 'Nova Atualização';
  let excerpt = post.copy_hook || '';

  const textLines = (post.copy_text || '').split('\n').filter(line => line.trim() !== '');
  const firstLine = textLines[0]?.trim();

  // A IA geralmente embute o título real no copy_text usando '# '
  if (firstLine?.startsWith('#')) {
    title = firstLine.replace(/^#+\s*/, '').trim();
    // O copy_hook nesse caso foi usado pela IA para ser o parágrafo "Isca/Resumo"
    excerpt = post.copy_hook || stripMarkdown(textLines.slice(1).join('\n'));
  } else {
    // Se não tiver H1, o título é o copy_hook e o excerpt é o começo do texto
    excerpt = stripMarkdown(post.copy_text || '');
  }

  // Corta o excerpt se ficar muito grande para o card
  if (excerpt.length > 150) {
    excerpt = excerpt.substring(0, 150) + '...';
  }

  return { title, excerpt };
}
